import React, { useEffect } from 'react';
import logo from '../../Assets/img/svg/logos/horizontalLogo.svg';
import birdLogo from '../../Assets/img/svg/logos/birdLogo.svg';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';
import NameHolder from 'Components/Reusable/Holders/NameHolder';
import { useStyles } from './header.style';
import { contents } from 'Utils/options';
import { IconHolder } from 'Components/Reusable/Buttons/Buttons';
import Button from '@material-ui/core/Button';
import { logoutUser } from 'ReduxStore/user/Action';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Routes } from 'Utils/Route';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { RootState } from 'ReduxStore';
import { GetAllKids } from 'ReduxStore/children/Action';
import { Redirect } from 'react-router-dom';

const logs = () => {
	localStorage.removeItem('token');
	localStorage.removeItem('currentChild');
	localStorage.removeItem('currentChildId');
	localStorage.removeItem('parentId');
};

const StyledMenu = withStyles({
	paper: {
		border: '1px solid #d3d4d5',
	},
})((props: MenuProps) => (
	<Menu
		elevation={0}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right',
		}}
		{...props}
	/>
));

const StyledMenuItem = withStyles(theme => ({
	root: {
		fontFamily: 'Poppins',
		fontSize: '16px',
		color: '#4D4D4D',
		'&:focus': {
			backgroundColor: 'white !important',
			'& .MuiListItemIcon-root, & .MuiListItemText-primary': {
				color: theme.palette.common.white,
			},
		},
		'&:hover': {
			backgroundColor: 'white !important',
			'& .MuiListItemIcon-root, & .MuiListItemText-primary': {
				color: theme.palette.common.white,
			},
		},
	},
}))(MenuItem);
interface HeaderParams {
	setName?: any;
}
const AdminHeader = ({ setName }: HeaderParams) => {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const matches = useMediaQuery('(max-width:440px)');
	const children = useSelector((state: RootState) => state.children.children);

	const dispatch = useDispatch();
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	// useEffect(() => {
	// 	const getParentsKids = async () => await GetAllKids()(dispatch);
	// 	getParentsKids();
	// }, []);

	const handleClose = () => {
		setAnchorEl(null);
	};
	const history = useHistory();
	const handleMenu = (event: React.MouseEvent<HTMLElement>, url: string, external: boolean) => {
		if (!external) {
			// setAnchorEl(event.currentTarget);
			// add a return so that  it can break the loop
			// history.push(url);
			window.open(url, '_self');
			return setAnchorEl(null);
		}
		return window.open('https://www.adventuretowntoys.com/', '_blank');
	};
	const handleLogout = () => {
		dispatch(logoutUser());
		history.push(Routes.AdminLogin);
	};
	const handleContactUs = (event?: Event) => {
		// const mailto ="mailto:mail@gmail.com?subject=Test subject&body=Body content";
		event?.preventDefault();
		const mailto = `mailto:${process.env.REACT_APP_CONTACT_EMAIL}`;
		return window.open(mailto);
	};
	return (
		<>
			<div className={classes.root}>
				<AppBar position="static">
					<Toolbar className={`${classes.header} d-flex flex-row justify-content-between`}>
						{matches ? (
							<img
								src={birdLogo}
								alt=""
								style={{ width: 50, cursor: 'pointer' }}
								onClick={() => window.open(Routes.AdminHome, '_self')}
							/>
						) : (
							<img
								src={logo}
								alt=""
								style={{ width: 250, cursor: 'pointer' }}
								onClick={() => window.open(Routes.AdminHome, '_self')}
							/>
						)}
						<section className="d-flex flex-nowrap">
							{/* <NameHolder setName={setName} /> */}
							<div>
								<IconButton
									edge="start"
									className={classes.menuButton}
									color="primary"
									aria-label="menu"
									onClick={handleClick}
									disableRipple={true}
									size="medium"
								>
									<MenuIcon />
								</IconButton>
								<StyledMenu
									id="customized-menu"
									anchorEl={anchorEl}
									keepMounted
									open={Boolean(anchorEl)}
									onClose={handleClose}
								>
									{/* {contents.map(item => (
										<StyledMenuItem
											className={classes.styledMenuItem}
											key={item.id}
											onClick={event => handleMenu(event, item.url, item.external)}
										>
											<IconHolder
												common={{ icon: item.menuIcon, radius: '300px', background: item.backgroundColor }}
											/>
											<h5 className="px-4">{item.type}</h5>
										</StyledMenuItem>
									))} */}
									{/* <Button
										variant="contained"
										component="div"
										onClick={() => handleContactUs(event)}
										className={classes.logout}
									>
										Contact Us
									</Button> */}
									<Button
										variant="contained"
										component="div"
										onClick={handleLogout}
										className={classes.logout}
									>
										Logout
									</Button>
								</StyledMenu>
							</div>
						</section>
					</Toolbar>
				</AppBar>
			</div>
		</>
	);
};

export default AdminHeader;
